import { useContext } from "react";
import { ConfigContext } from "../../context/configContext";

const Socials = () => {

    const { about } = useContext(ConfigContext);

    return (
        <div className="mt-5 d-flex flex-column">
            <strong className="fs-3 mt-5">Let's get social</strong>
            <p>Follow me on Facebook, Twitter, Linkeding and Github.</p>
            <div className="d-flex ">
                <a
                    href={about.facebook}
                    target="_blank"
                    style={{
                        backgroundColor: '#3b5998',
                        color: '#fff',
                    }}
                    className="btn btn-default d-flex align-items-center me-2">
                    <i className="bi bi-facebook fs-3" /> &nbsp;
                    <span className="d-none d-md-inline">
                        Facebook
                    </span>
                </a>

                <a
                    href={about.twitter}
                    target="_blank"
                    style={{
                        backgroundColor: '#00acee',
                        color: '#fff'
                    }}
                    className="btn btn-default d-flex align-items-center me-2">
                    <i className="bi bi-twitter fs-3" /> &nbsp;
                    <span className="d-none d-md-inline">
                        Twitter
                    </span>
                </a>

                <a
                    href={about.linkedin}
                    target="_blank"

                    className="btn btn-default d-flex align-items-center me-2"
                    style={{
                        backgroundColor: '#0e76a8',
                        color: '#fff'
                    }}
                >
                    <i className="bi bi-linkedin fs-3" /> &nbsp;
                    <span className="d-none d-md-inline">
                        Linkeding
                    </span>
                </a>

                <a
                    href={about.github}
                    target="_blank"

                    className="btn btn-default d-flex align-items-center "
                    style={{
                        backgroundColor: '#4E545A',
                        color: '#fff'
                    }}

                >
                    <i className="bi bi-github fs-3" /> &nbsp;
                    <span className="d-none d-md-inline">
                        Github
                    </span>
                </a>
            </div>
        </div>
    )

}

export default Socials;